import { render, staticRenderFns } from "./bzbj.vue?vue&type=template&id=e477ac78&scoped=true&"
import script from "./bzbj.vue?vue&type=script&lang=js&"
export * from "./bzbj.vue?vue&type=script&lang=js&"
import style0 from "./bzbj.vue?vue&type=style&index=0&id=e477ac78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e477ac78",
  null
  
)

export default component.exports